import utils from '../utils';

const ListingFilters = {
	filterGroups: [...document.querySelectorAll('[data-filter-group]')].filter(group => group),
	loadMore: document.querySelector('[data-load-more-posts]'),
	activeFilters: new Map(),
	activeFilterGroups: [],
	activeFiltersOutput: document.querySelector('[data-active-filters-output]'),
	activeFiltersWrapper: document.querySelector('[data-active-filters-wrapper]'),
	activeFiltersClearAll: document.querySelector('[data-clear-all-filters]'),
	searchString: '',
	init: () => {
		ListingFilters.toggleOptionsVisibility();
		ListingFilters.handleFilters();
		ListingFilters.handleClearAllFiltersButton();
		ListingFilters.handleSearchInput();
		ListingFilters.loadMorePosts();
		ListingFilters.changeMobileLabels();
		ListingFilters.handleMobileFilters();
	},
	toggleOptionsVisibility: () => {
		if (!ListingFilters.filterGroups.length) return;

		ListingFilters.filterGroups.forEach(group => {
			const output = group.querySelector('[data-filter-group-output]');
			if (!output) return;

			output.addEventListener('click', () => group.classList.toggle('listing-filters-group--active'));

			document.body.addEventListener('click', event => {
				if (group.contains(event.target) || output.contains(event.target)) return;

				group.classList.remove('listing-filters-group--active');
			})
		})
	},
	handleFilters: () => {
		if (!ListingFilters.filterGroups.length) return;

		ListingFilters.filterGroups.forEach((group) => {
			ListingFilters.activeFilterGroups[group.getAttribute('data-filter-group')] = new Map();

			const inputs = document.querySelectorAll('[data-filter-group-input]');
			if (!inputs.length) return;

			inputs.forEach(input => input.addEventListener('change', (e) => {
				e.stopImmediatePropagation();

				const group = ListingFilters.filterGroups.find(group => group.getAttribute('data-filter-group') === input.getAttribute('data-filter-group-key'));

				if (input.checked) {
					ListingFilters.activeFilterGroups[input.getAttribute('data-filter-group-key')].set(input.value, input.getAttribute('data-filter-group-input'));
					ListingFilters.activeFilters.set(input.value, input.getAttribute('data-filter-group-input'));
				} else {
					ListingFilters.activeFilterGroups[input.getAttribute('data-filter-group-key')].delete(input.value);
					ListingFilters.activeFilters.delete(input.value);
				}

				if (!group) return;
				const output = group.querySelector('[data-filter-group-output]');

				if (ListingFilters.activeFilterGroups[input.getAttribute('data-filter-group-key')].size) {
					group.classList.add('listing-filters-group--selected');
					output.textContent = window.matchMedia('(max-width: 1024px)').matches ? `${output.getAttribute('data-selected-label')}` : `${output.getAttribute('data-selected-label')} (${ListingFilters.activeFilterGroups[input.getAttribute('data-filter-group-key')].size})`;
				} else {
					group.classList.remove('listing-filters-group--selected');
					output.textContent = window.matchMedia('(max-width: 1024px)').matches ? `${output.getAttribute('data-selected-label')}` : `${output.getAttribute('data-unselected-label')}`;
				}

				ListingFilters.renderActiveFilters();
				ListingFilters.filterPosts();
			}))
		})
	},
	renderActiveFilters: () => {
		if (!ListingFilters.activeFiltersOutput || !ListingFilters.activeFiltersWrapper || !ListingFilters.activeFiltersClearAll) return;

		if (ListingFilters.activeFilters.size) {
			ListingFilters.activeFiltersOutput.classList.add('listing-filters-output--visible');
		} else {
			ListingFilters.activeFiltersOutput.classList.remove('listing-filters-output--visible');
		}

		const filters = document.querySelectorAll('[data-active-filter]');
		const fragment = document.createDocumentFragment();

		filters.forEach(filter => filter.remove());

		for (const [id, name] of ListingFilters.activeFilters) {
			const filter = document.createElement('div');

			filter.classList.add('listing-filters-output__filter');
			filter.setAttribute('data-active-filter', '');
			filter.innerHTML = `<p class="listing-filters-output__filter-label">${name}</p>
					<button class="listing-filters-output__filter-clear" data-clear-filter="${id}"></button>`

			fragment.append(filter);
		}

		ListingFilters.activeFiltersWrapper.insertBefore(fragment, ListingFilters.activeFiltersClearAll);
		ListingFilters.handleClearFilterButton();

		if (!window.matchMedia('(max-width: 1024px)').matches) return;

		const filtersMobileOutput = document.querySelector('[data-mobile-listing-filters-quantity]');
		if (!filtersMobileOutput) return;

		filtersMobileOutput.textContent = ListingFilters.activeFilters.size;

		if (ListingFilters.activeFilters.size) {
			filtersMobileOutput.classList.add('listing-header__filters-quantity--active');
		} else {
			filtersMobileOutput.classList.remove('listing-header__filters-quantity--active');
		}
	},
	handleClearFilterButton: () => {
		const buttons = document.querySelectorAll('[data-clear-filter]');
		if (!buttons.length) return;

		buttons.forEach(button => button.addEventListener('click', () => {
			const input = document.querySelector(`[data-filter-group-input][value="${button.getAttribute('data-clear-filter')}"]`);

			const event = new Event('change');

			input.checked = false
			input.dispatchEvent(event);
		}));
	},
	handleClearAllFiltersButton: () => {
		if (!ListingFilters.activeFiltersClearAll) return;

		ListingFilters.activeFiltersClearAll.addEventListener('click', () => {
			const inputs = document.querySelectorAll(`[data-filter-group-input]:checked`);
			if (!inputs.length) return;

			inputs.forEach(input => {
				const event = new Event('change');

				input.checked = false
				input.dispatchEvent(event);
			});
		})
	},
	handleSearchInput: () => {
		const searchInput = document.querySelector('[data-listing-search]');
		if (!searchInput) return;

		ListingFilters.searchString = searchInput.value;

		searchInput.addEventListener('input', utils.debounce(() => {
			ListingFilters.searchString = searchInput.value;
			ListingFilters.filterPosts()
		}, 1000))
	},
	prepareRequestData: (formData, postType) => {
		if (ListingFilters.searchString) {
			formData.append('search_string', ListingFilters.searchString);
		}

		let years = '';

		if (ListingFilters.activeFilters.size) {
			const groups = [];
			let months = '';

			for (const [key, value] of Object.entries(ListingFilters.activeFilterGroups)) {
				if (key === 'years') {
					years = `${[...value.keys()].join(',')}`;
				} else if (key === 'months') {
					months = `${[...value.keys()].join(',')}`;
				} else {
					const groupAndValues = `${key}:${[...value.keys()].join(',')}`
					groups.push(groupAndValues);
				}
			}

			formData.append('categories', groups.join('/'));
			formData.append('months', months);
		}

		if (postType === 'events') {
			years = ListingFilters.prepareYearsOfEventsListing();
		}

		if (years) {
			formData.append('years', years);
		}

		return formData;
	},
	filterPosts: async () => {
		const loadMoreContainer = document.querySelector('[data-load-more-container]');
		const wrapper = document.querySelector('[data-events-listing-wrapper]');
		const quantity = document.querySelector('[data-listing-quantity]');
		if (!wrapper || !quantity) return;

		let data = new FormData();

		const postType = wrapper.getAttribute('data-post-type');

		data.append('action', 'filter_posts');
		data.append('post_type', postType);
		data.append('listing_nonce', scripts_vars.listing_nonce);

		data = ListingFilters.prepareRequestData(data, postType);

		wrapper.classList.add('events-listing__wrapper--loading');

		const response = await fetch(scripts_vars.ajax_url, {
			method: 'POST',
			body: data,
		});

		const body = await response.json();
		if (!body) return;

		wrapper.classList.remove('events-listing__wrapper--loading');

		wrapper.innerHTML = body.html;
		quantity.innerHTML = `(${body.quantity})`;

		if (!loadMoreContainer || !ListingFilters.loadMore) return;

		if (body.quantity <= 9) {
			ListingFilters.loadMore.remove();
		} else {
			loadMoreContainer.appendChild(ListingFilters.loadMore);
			ListingFilters.loadMore.setAttribute('data-offset', 9);
		}

		ListingFilters.loadMore.setAttribute('data-max-posts', body.quantity);
	},
	loadMorePosts: () => {
		const wrapper = document.querySelector('[data-events-listing-wrapper]');
		if (!ListingFilters.loadMore || !wrapper) return;

		ListingFilters.loadMore.addEventListener('click', async () => {
			let data = new FormData();

			const postType = wrapper.getAttribute('data-post-type');

			const offset = +ListingFilters.loadMore.getAttribute('data-offset');
			const maxPosts = +ListingFilters.loadMore.getAttribute('data-max-posts');

			data.append('action', 'load_more_posts');
			data.append('offset', offset);
			data.append('post_type', postType);
			data.append('listing_nonce', scripts_vars.listing_nonce);

			data = ListingFilters.prepareRequestData(data, postType);

			const response = await fetch(scripts_vars.ajax_url, {
				method: 'POST',
				body: data,
			});

			const body = await response.json();
			if (!body) return;

			if (offset + body.quantity >= maxPosts) ListingFilters.loadMore.remove();
			ListingFilters.loadMore.setAttribute('data-offset', offset + body.quantity);

			wrapper.innerHTML = wrapper.innerHTML += body.html;
		})
	},
	changeMobileLabels: () => {
		if (!window.matchMedia('(max-width: 1024px)').matches) return;

		const outputs = document.querySelectorAll('[data-filter-group-output]');
		if (!outputs.length) return;

		outputs.forEach(output => output.textContent = output.getAttribute('data-selected-label'));
	},
	handleMobileFilters: () => {
		if (!window.matchMedia('(max-width: 1024px)').matches) return;

		const filters = document.querySelector('[data-mobile-listing-filters]');
		const open = document.querySelector('[data-mobile-listing-filters-open]');
		const close = document.querySelector('[data-mobile-listing-filters-close]');
		if (!filters || !open || !close) return;

		open.addEventListener('click', () => filters.classList.add('listing-filters--active'));
		close.addEventListener('click', () => filters.classList.remove('listing-filters--active'));
	},
	prepareYearsOfEventsListing: () => {
		const inputs = document.querySelectorAll('[data-filter-group-key="years"]');
		if (!inputs.length) return '';

		const years = [];
		inputs.forEach(input => years.push(input.value));

		return years.join(',');
	},
};

export default ListingFilters;
